import BookmarkStorage from "../../bookmark/js/BookmarkStorage";
import RenderCards from "../../../utilities/cards/RenderCards";

export default class BookmarkPage extends BookmarkStorage {
  config = {
    resultSelector: ".bookmarks__results",
    noBookmarks: "<p class='fade-in'>Sorry, no bookmarks available.</p>",
    templateId: "bookmark-template",
    buttonClass: ".bookmark_button",
  };

  constructor(config = {}) {
    super(config);
    this.config = { ...this.config, ...config };

    // render the results?
    if (this.config.resultSelector) {
      this.resultsElem = document.querySelector(this.config.resultSelector);

      // render list if not empty
      if (this.resultsElem) this.renderBookmarkCards();
    }
  }

  attachHandlers() {
    // the bookmark buttons
    this.buttonElements = document.querySelectorAll(this.config.buttonClass);

    // Add event listeners for delete
    if (this.buttonElements) {
      this.buttonElements.forEach((input) => {
        input.addEventListener("click", this.handleClick.bind(this));
      });
    }
  }

  // display empty message if list is empty
  checkEmpty() {
    if (!this.list.length) {
      this.resultsElem.insertAdjacentHTML("beforeend", this.config.noBookmarks);
      return true;
    }
  }

  // render the list of bookmark cards
  renderBookmarkCards() {
    // render the template
    const data = {
      list: this.list,
      resultElement: this.resultsElem,
      noResults: this.config.noBookmarks,
      templateId: this.config.templateId,
    };

    const render = new RenderCards(data);
    this.resultsElem.innerHTML = render.render();

    setTimeout(() => {
      render.hydrate();
      // attach event handlers
      this.attachHandlers();
    }, 250);
  }

  // Remove a bookmark and re-render the list
  handleClick = (event) => {
    event.preventDefault();
    // this is now the input element
    let data = event.target.dataset.bookmark;
    if (data) {
      try {
        data = JSON.parse(atob(data));
        this.deleteBookmark(data);
        this.renderBookmarkCards();
      } catch (e) {
        console.log("BookmarkPage:handleClick:", e);
      }
    }
  };
}
